import React, { useEffect, useState } from 'react';
import { ThreeCircles } from 'react-loader-spinner';
import { toast } from 'react-toastify';
import { virtualMallSingleIdProductTreeApi } from './VirtualMallApi/api';
import './VirtualMallSingleIdProducts.scss';

function TreeNode({ user }) {
    return (
        <div className="single-id-tree-node">
            <article className="single-id-tree-card">
                <span className="single-id-tree-level">Level {user.level}</span>
                <span className="single-id-tree-avatar" aria-hidden="true">
                    {(user.vu_name || 'U').trim().charAt(0).toUpperCase()}
                </span>
                <strong>{user.vu_name || 'Unnamed user'}</strong>
                <span>ID: {user.vu_referal_id}</span>
                {user.vu_mobile && <span>Mobile: {user.vu_mobile}</span>}
            </article>
            {user.children?.length > 0 && (
                <div className="single-id-tree-children">
                    {user.children.map((child) => <TreeNode key={child.vu_id} user={child} />)}
                </div>
            )}
        </div>
    );
}

export default function VirtualMallSingleIdsTree() {
    const [tree, setTree] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let cancelled = false;
        const loadTree = async () => {
            setLoading(true);
            try {
                const response = await virtualMallSingleIdProductTreeApi();
                if (!cancelled) setTree(response?.status ? response.data : null);
            } catch (error) {
                console.error('Failed to load Single IDs Tree:', error);
                if (!cancelled) toast.error(error.response?.data?.message || 'Failed to load Single IDs Tree.');
            } finally {
                if (!cancelled) setLoading(false);
            }
        };
        loadTree();
        return () => { cancelled = true; };
    }, []);

    return (
        <section className="dashboard-section single-id-products-section">
            {/* <h2>Single IDs Tree</h2> */}
            {loading ? (
                <div className="single-id-products-loading">
                    <ThreeCircles height="64" width="64" color="#667eea" visible />
                </div>
            ) : tree ? (
                <>
                    {/* <p className="single-id-tree-intro">The matrix fills by level: 1, 3, 9, then up to 27 Single IDs.</p> */}
                    <div className="single-id-tree-root">
                        <div className="single-id-tree-canvas">
                            <TreeNode user={tree} />
                        </div>
                    </div>
                </>
            ) : (
                <div className="single-id-products-empty">Your Single IDs Tree will appear here after your first Single ID Product order is approved.</div>
            )}
        </section>
    );
}
